<template>
    <span>
        <b-button :variant="variant" @click.stop="voltar()" :class="cssProp">
            <span><i class="fa fa-history"></i> {{ btnTitle }}</span>
        </b-button>
    </span>
</template>

<script>
export default {
    name: 'BtnVoltar',
    props: {
        btnTitle: {
            type: String,
            default: 'Voltar'
        },

        variant: {
            type: String,
            default: 'warning'
        },

        cssProp: {
            type: String,
            default: ''
        },

        rota: {
            type: String,
            default: () => ''
        }
    },

    methods: {
        voltar() {
            if (this.rota != '') {
                this.$router.push({ name: this.rota })
            } else {
                this.$router.go(-1)
            }
        }
    }
}
</script>
